import home from './messages-home.json';
import contact from './messages-contact.json';
import services from './messages-services.json';
import portal from './messages-portal.json';
import extra from './messages-extra.json';
import assistant from './messages-assistant.json';
import redesign from './messages-redesign.json';
import news from './messages-news.json';
import navigation from './messages-navigation.json';
import privacy from './messages-privacy.json';
import purposeVideo from './messages-purpose-video.json';
import footer from './messages-footer.json';
const rows = [...home, ...contact, ...services, ...portal, ...extra, ...assistant, ...redesign, ...news, ...navigation, ...privacy, ...purposeVideo, ...footer];
export const localeCodes = ['en','zh','ru','de','fr'];
const dictionaries = Object.fromEntries(localeCodes.map((code,index) => [code, Object.fromEntries(rows.map(row => [row[0], row[index + 1]]))]));
export function translate(text, language = 'es') {
  if (typeof text !== 'string' || language === 'es') return text;
  const trimmed = text.trim();
  const found = dictionaries[language]?.[trimmed];
  if (found) return text.replace(trimmed, found);
  const country = trimmed.match(/^(.+) (\(\+\d+\))$/);
  if (country) return `${translate(country[1], language)} ${country[2]}`;
  const date = trimmed.match(/^(\d{1,2}) (ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)(?: (\d{4}))?$/i);
  if (date) return new Intl.DateTimeFormat(language === 'zh' ? 'zh-Hans' : language, { day: 'numeric', month: 'short', ...(date[3] ? { year: 'numeric' } : {}), timeZone: 'UTC' }).format(new Date(Date.UTC(Number(date[3] || 2026), ['ene','feb','mar','abr','may','jun','jul','ago','sep','oct','nov','dic'].indexOf(date[2].toLowerCase()), Number(date[1]))));
  if (trimmed.startsWith('Último pago · ')) return `${translate('Último pago', language)} · ${translate(trimmed.slice(14), language)}`;
  if (/^Ver BZ-/.test(trimmed)) return `${translate('Ver', language)} ${trimmed.slice(4)}`;
  const scene = trimmed.match(/^Ver escena (\d+): (.+)$/);
  if (scene) return `${translate('Ver escena', language)} ${scene[1]}: ${translate(scene[2], language)}`;
  const announcement = trimmed.match(/^Escena (\d+) de (\d+): (.+)$/);
  if (announcement) return `${translate('Escena', language)} ${announcement[1]} / ${announcement[2]}: ${translate(announcement[3], language)}`;
  if (trimmed.startsWith('LinkedIn de ')) return `LinkedIn: ${trimmed.slice(12)}`;
  const control = trimmed.match(/^CENTRO DE CONTROL \/ (\d+)$/);
  if (control) return `${translate('Centro de control', language)} / ${control[1]}`;
  const possibility = trimmed.match(/^POSIBILIDAD (\d+)$/);
  if (possibility) return `${translate('Ejemplo', language)} ${possibility[1]}`;
  return text;
}
export const translatedMessages = rows;
